module.exports = __webpack_public_path__ + "img/tapon_1.5f10513e.jpg";